export default __webpack_public_path__ + "static/jakubz-92b3e55f4791daf3cf5e438288923d84.jpg";